import { render, staticRenderFns } from "./TourDetailTip.vue?vue&type=template&id=d117ab60"
import script from "./TourDetailTip.js?vue&type=script&lang=js&external"
export * from "./TourDetailTip.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports